import RoleEnum from "constants/RoleEnum";
import RouteEnum from "constants/RouteEnum";
import IStore from "models/IStore";
import IUserCookieModel from "models/common-models/IUserCookieModel";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Dispatch } from "redux";
import * as AuthAction from "stores/auth/AuthAction";
import { checkPath, getSelectedUserProfile, unapprovedProfileRedirection } from "utilities/UserProfileRoleUtility";

interface IProps {
  readonly path?: string;
}

const AuthGuard: React.FC<IProps> = ({ path }) => {
  const dispatch: Dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const cookieSelectedProfile: string | undefined = getSelectedUserProfile();
  const stateToken: string | null = useSelector((state: IStore) => state.auth.token);
  const stateSelectedProfile: string | undefined = useSelector((state: IStore) => state.auth.selectedProfile);
  const stateUser: IUserCookieModel | null = useSelector((state: IStore) => state.auth.user);

  useEffect(() => {
    if (!stateToken) {
      dispatch(AuthAction.setRedirectPath(location.pathname));
      navigate(RouteEnum.Login, { replace: true });
    } else {
      if (!stateSelectedProfile) {
        if (!checkPath(location.pathname)) {
          dispatch(AuthAction.setRedirectPath(location.pathname));
          navigate(RouteEnum.ProfileCreate);
        }
      } else if (cookieSelectedProfile !== stateSelectedProfile) {
        if (cookieSelectedProfile) {
          dispatch(AuthAction.setSelectedProfile(cookieSelectedProfile));
        } else {
          dispatch(AuthAction.removeSelectedProfile());
        }
      } else {
        if (stateUser && path) {
          if (
            stateSelectedProfile === RoleEnum.ProductionCompany &&
            !stateUser.companies.production_company?.is_approved &&
            !unapprovedProfileRedirection(path, RoleEnum.ProductionCompany)
          ) {
            dispatch(AuthAction.setRedirectPath(location.pathname));
            navigate(RouteEnum.ProfileCreate);
          } else if (
            stateSelectedProfile === RoleEnum.CastAgency &&
            !stateUser.companies.cast_agency?.is_approved &&
            !unapprovedProfileRedirection(path, RoleEnum.CastAgency)
          ) {
            dispatch(AuthAction.setRedirectPath(location.pathname));
            navigate(RouteEnum.ProfileCreate);
          } else if (
            stateSelectedProfile === RoleEnum.Client &&
            !stateUser.companies.client?.is_approved &&
            !unapprovedProfileRedirection(path, RoleEnum.Client)
          ) {
            dispatch(AuthAction.setRedirectPath(location.pathname));
            navigate(RouteEnum.ProfileCreate);
          } else if (
            stateSelectedProfile === RoleEnum.Actor &&
            !stateUser.actor_approved &&
            !unapprovedProfileRedirection(path, RoleEnum.Actor)
          ) {
            dispatch(AuthAction.setRedirectPath(location.pathname));
            navigate(RouteEnum.ProfileCreate);
          }
        }
      }
    }
  }, [stateToken, stateSelectedProfile, cookieSelectedProfile, stateUser, path, location.pathname, dispatch, navigate]);

  if (!stateToken) {
    return null;
  }

  return <Outlet />;
};

export default AuthGuard;